// API Configuration - Controls whether to use mock data or real backend

// Determine if we should use mock data based on environment variable or localStorage
const shouldUseMockData = () => {
  // In production builds, default to not using mock data
  if (process.env.NODE_ENV === 'production') {
    // Only use mock data in production if explicitly set to true
    return process.env.REACT_APP_USE_MOCK_DATA === 'true';
  }
  
  // Check environment variable first
  if (process.env.REACT_APP_USE_MOCK_DATA === 'true') {
    return true;
  }
  
  if (process.env.REACT_APP_USE_MOCK_DATA === 'false') {
    return false;
  }
  
  // Check localStorage setting
  const mockDataSetting = localStorage.getItem('useMockData');
  if (mockDataSetting !== null) {
    return mockDataSetting === 'true';
  }
  
  // Default to true (use mock data) to prevent connection errors in development
  return true;
};

// Determine API base URL
const getApiUrl = () => {
  // Use environment variable if set
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Default to /get path to match backend service
  return '/get';
};

// Export configuration
export const API_CONFIG = {
  useMockData: shouldUseMockData(),
  
  // API base URL for real backend
  apiUrl: getApiUrl(),
  
  // Toggle mock data usage
  toggleMockData: (useMock) => {
    localStorage.setItem('useMockData', useMock.toString());
    window.location.reload();
  }
};

export default API_CONFIG;